import { useTranslation } from 'react-i18next'
import { Page } from '../../ui'

import logoIcon from './assets/images/logo.svg'
import qrImage from './assets/images/qr-code.png'

import c from './assets/scss/page.module.scss'

const DesktopPage = () => {
    const { t } = useTranslation()
    console.log('Desktop Page')
    return (
        <Page>
            <div className={c.component}>
                <img src={logoIcon} alt="QR" className={c.logo} />

                <div className={c.qr}>
                    <img src={qrImage} alt="QR" />
                    <span>@gg_funny_bot</span>
                </div>

                <div className={c.block}>
                    <p className={c.title}>
                        {t('desktop.title')} <br />
                        <b>{t('desktop.titleBold')}</b>
                    </p>
                    <p className={c.text}>{t('desktop.text')}</p>
                </div>
            </div>
        </Page>
    )
}

export default DesktopPage
